import { useBuyOffer as u } from "../../../pages/checkout/api/index.mjs";
const t = () => {
  const { buyOffer: r, isFetching: e } = u();
  return {
    mercadoPagoCardBuyOffer: (f, o) => r(f, o),
    isFetching: e
  };
};
export {
  t as useMercadoPagoCardBuyOffer
};
